/**
 * The transpose Live has, as OPButtons shows it (operator 2026-11-03, decision 6: "newest wins").
 *
 * The newer of the song's transpose (OPBridge's `last_sent`, `observedTranspose`) and a manual tap a computer TOOK
 * (`lastTransposeSend`, recorded only when delivered) - the Waves tile's rule (`autotune/readback.ts` `newestWins`).
 * Before, a manual tap stayed half-lit as "pending" until the next song, the Displays said the song's value, and a Rig
 * State captured after the tap stored the song's value, so recalling it undid the tap (audit G-4).
 */
import { newestWins } from '../autotune/readback.ts';
import { lastTransposeSend } from './session.ts';
import { observedTranspose, setlistState, type SetlistMirror } from '../setlist/state.ts';

export function transposeShown(m: SetlistMirror = setlistState()): number | null {
  return newestWins(observedTranspose(m), lastTransposeSend(), m);
}
